// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html body,\nhtml {\n  padding: 0;\n  margin: 0;\n  font-family: \"Inter\", sans-serif;\n  height: 100%;\n  width: 100%;\n}\n\n* {\n  box-sizing: border-box;\n}\n\n@media (min-width: 1600px) {\n  .custom-wide-container {\n    min-width: 1550px;\n  }\n}\n@media (min-width: 1900px) {\n  .custom-wide-container {\n    min-width: 1800px;\n  }\n}", ""]);
// Exports
module.exports = exports;
